// components/DashboardTour.jsx
import React from 'react';
import Joyride from 'react-joyride';

const DashboardTour = ({ run }) => (
  <Joyride
    steps={[
      { target: '.menu-devices', content: 'Aquí gestionas tus dispositivos' },
      { target: '.menu-tutorials', content: 'Aquí encuentras los tutoriales' },
    ]}
    continuous
    showSkipButton
    run={run}
  />
);

export default DashboardTour;
